module.exports = __webpack_public_path__ + "img/img_27.b96775cf.png";